export default "__VITE_ASSET__d761f3b7__"